export const MutateKeys = {
  CREATE_JOB_LEAD: "createJobLead",
  SAVE_JOB_LEAD_DRAFT_KEY: "saveJobLeadDraftKey",
  MILES_KEY: "milesKey",
  GET_TOP_QUARRIES: "getTopQuarries",
  ADD_DOCUMENTS_MUTATE_KEY: "addDocuments",
  CREATE_TRUCK_MATERIAL_KEY: "truckMaterial",
  UPDATE_QUOTE_ESTIMATE: "updateQuoteEstimate",
  ADD_CONTACT_KEY: "addContact",
  EDIT_CONTACT_KEY: "editContactJobLead",
  SAVE_INTERNAL_APPROVAL: "saveInternalApproval",
  APPROVE_INTERNAL_DOCUMENTS_KEY: "approveInternalDocuments",
  DELETE_DOCUMENTS_KEY: "deleteDocuments",
  APPROVE_DISPATCH_KEY: "approveDispatch",
  BYPASS_L2_APPROVAL_KEY: "bypassL2Approval",
  APPROVE_INTERNAL_COMPLETE_KEY: "approveInternalComplete",
  ADD_CUSTOMER_MUTATE_KEY: "addCustomerKey",
  SAVE_TICKET_MUTATE_KEY: "saveTicketKey",
  SAVE_DATA_INPUT_KEY: "saveDataInputKey",
  REPLACE_TICKET_KEY: "replaceTicket",
  REPLACE_FILE_KEY: "replaceFile",
  UPDATE_QUARRY_MUTATE_KEY: "updateQuarryKey",
  PATCH_ARCHIVED_TICKET_KEY: "patchArchivedTicketKey",
  SUBMIT_TICKET_PROCESSING_DETAILS_KEY: "submitTicketProcessingDetailsKey",
  REPLACE_REVIEW_TICKET_KEY: "replaceReviewTicket",
  UPDATE_RULE_ENGINE_KEY: "updateRuleEngineKey",
  ARCHIVE_TICKET_KEY: "archiveTicketKey",
  MODIFY_ROLES: "modifyRoles",
  ADD_EXTERNAL_ROLE_KEY: "addExternalRoleKey",
  EDIT_EXTERNAL_ROLE_KEY: "editExternalRoleKey",
  DELETE_EXTERNAL_ROLE_KEY: "deleteExternalRoleKey",
  GET_TILE_INVOICE_DOWNLOAD_KEY: "getTileInvoiceDownloadKey",
  GET_LIST_INVOICE_DOWNLOAD_KEY: "getListInvoiceDownloadKey",
  GET_LIST_INVOICE_CARRIER_DOWNLOAD_KEY: "getListInvoiceCarrierDownloadKey",
  GET_LIST_QUICKBOOKS_EXPORT_KEY: "getListQuickbooksExportKey",
  FETCH_INVOICE_META_KEY: "fetchInvoiceMetaKey",
  GENERATE_INVOICES_KEY: "generateInvoicesKey",
  UPDATE_QUARRY_MATERIAL_TAX_KEY: "updateMaterialTaxKey",
  UPDATE_INVOICE_STATUS_KEY: "updateInvoiceStatusKey",
  ARCHIVE_INVOICE_KEY: "archiveInvoiceKey",
  SYNC_WITH_QUICKBOOKS_KEY: "syncQuickBooksKey",
  DOWNLOAD_ALL_LIEN_KEY: "downloadBatches",
  EXPORT_NON_SYNCED_KEY: "exportNonSyncRecords",
  DOWNLOAD_SINGLE_BATCH_KEY: "downloadSingleBatches",
  GET_PRESIGNED_URL_KEY: "getPresignedUrlKey",
  ADD_DATABASE_ENTRIES_KEY: "addDatabaseEntriesKey",
  DELETE_DATABASE_ENTRIES_KEY: "deleteDatabaseEntriesKey",
  EDIT_DATABASE_ENTRIES_KEY: "editDatabaseEntriesKey",
  CREATE_CUSTOMER_ENTRY_KEY: "createCustomerEntryKey",
  ARCHIVE_CUSTOMER_ENTRY_KEY: "archiveCustomerEntryKey",
  SYNC_CUSTOMER_DATABASE_KEY: "syncCustomerDatabaseKey",
  GET_CUSTOMER_GOOGLE_DETAILS_KEY: "getCustomerGoogleDetailsKey",
  UPDATE_CUSTOMER_DETAILS_KEY: "updateCustomerDetailsKey",
  UPDATE_CUSTOMER_NOTES_KEY: "updateCustomerNotesKey",
  GET_CUSTOMER_DETAILS_EDIT_KEY: "getCustomerDetailsEditKey",
  GET_ACCOUNT_TERMS_OPTIONS_KEY: "getAccountTermsOptionsKey",

  ARCHIVE_JOB_DATABASE_ENTRY_KEY: "archiveJobDatabaseEntryKey",
  JOB_DATABASE_JOBNO_META_KEY: "fetchJobDatabaseJobNoMetaKey",
  JOB_DATABASE_JOBNAME_META_KEY: "fetchJobDatabaseJobNameMetaKey",
  JOB_DATABASE_CUSTOMER_META_KEY: "fetchJobDatabaseCustomerMetaKey",
  JOB_DATABASE_JOBTYPE_META_KEY: "fetchJobDatabaseJobtypeMetaKey",
  JOB_DATABASE_EQUIPMENT_META_KEY: "fetchJobDatabaseEquipmentMetaKey",
  JOB_DATABASE_MATERIAL_CATERGORY_META_KEY:
    "fetchJobDatabaseMaterialCategoryMetaKey",
  JOB_DATABASE_MATERIAL_TYPE_META_KEY: "fetchJobDatabaseMaterialTypeMetaKey",
  JOB_DATABASE_SALES_PERSON_META_KEY: "fetchJobDatabaseSalesPersonMetaKey",
  BLOCK_UNBLOCK_JOB_KEY: "blockUnblockJobKey",
  BULK_SYNC_STATUS_UPDATE_KEY: "bulkSyncStatusKey",
  ADD_NEW_QUARRY_KEY: "addNewQuarryKey",
  FETCH_QUARRY_MATERIAL_SUBCATEGORY_KEY: "fetchQuarryMaterialSubcategoryKey",
  ADD_NEW_MATERIAL_NAME_KEY: "addNewMaterialNameKey",
  ADD_NEW_QUARRY_MATERIAL_KEY: "addNewQuarryMaterialKey",
  EDIT_QUARRY_MATERIAL_KEY: "editQuarryMaterialKey",
  DELETE_QUARRY_MATERIAL_KEY: "deleteQuarryMaterialKey",
  DOWNLOAD_ALL_MATERIAL_IMAGES_KEY: "downloadAllMaterialImagesKey",
  SYNC_QUARRY_QUICKBOOKS_KEY: "syncQuarryQuickbooksKey",
  ADD_MATERIAL_IMAGES_KEY: "addMaterialImagesKey",
  DELETE_MATERIAL_IMAGE_KEY: "deleteMaterialImageKey",
  SET_CONTACT_STATUS_KEY: "setContactStatusKey",
  UPDATE_QUARRY_NOTES_KEY: "updateQuarryNotesKey",
  RESTORE_ARCHIVE_RECORD_KEY: "restoreArchiveRecordKey",
  DELETE_ARCHIVE_RECORD_KEY: "deleteArchiveRecordKey",
  SEND_VIA_EMAIL_KEY: "sendViaEmailKey",
  BLOCK_UNBLOCK_JOB_ORDER_KEY: "blockUnblockJobOrderKey",
  GET_JOB_DETAILS_KEY: "getJobDetailsKey",
  BULK_STATUS_UPDATE_KEY: "bulkStatusUpdateKey",
  INITIATE_RECALL_ACTION_KEY: "initiateRecallActionKey",
  GET_RECALL_INVOICE_DETAILS_KEY: "getRecallInvoiceDetailsKey",
  INITIATE_DOWNLOAD_ORIGINAL_FILE_KEY: "initiateDownloadOriginalFileKey",
  UPDATE_TICKET_LOCK_KEY: "updateTicketLockKey",
  GET_QUICKBOOK_SYNC_STATUS_KEY: "getQuickBookSyncStatusKey",
  FETCH_LEAD_DETAIL_KEY: "fetchLeadDetail",
  GET_AFFECTED_JOBS_FOR_QUARRY_COUNT_KEY:"getAffectedJobsForQuarryCountKey",
  GET_AFFECTED_JOBS_COUNT_KEY: "getAffectedJobsCountKey",
  ACCEPT_REVISED_PRICE_KEY: "acceptRevisedPriceKey",
  REJECT_REVISED_PRICE_KEY: "rejectRevisedPriceKey",
};
